<template>
  <div class="ret-login">
    <v-card class="ret-card">
      <v-card-text>
        <form>
          <v-text-field
            v-model="item.password"
            :label="$t('new-password')"
            type="password"
          ></v-text-field>
          <v-text-field
            v-model="item.passwordConfirmation"
            :label="$t('new-password-again')"
            type="password"
          ></v-text-field>
          <v-btn @click="onChangePassword" color="primary">{{ $t('change-password') }}</v-btn>
        </form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      item: {
        password: '',
        passwordConfirmation: ''
      }
    }
  },
  methods: {
    onChangePassword () {
      // TODO
      // this.$store.dispatch('changeOwnPassword', {user: this.item})
      // this.$router.push({name: 'home'})
    }
  }
}
</script>
